export default __webpack_public_path__ + "static/media/carolina-alves-book.e82bd5de.png";